import { Loader, Group } from "@mantine/core";
import { CustomText } from "../CustomText/CustomText";
import useIsDesktop from "../../../hooks/useIsDesktop";

export default function CustomLoader({
  type = "oval",
  text = "",
  textPosition = "left",
  textColor = "text-black",
  textSize,
  size,
  color = "white",
  gap = "xs",
}) {
  const isDesktop = useIsDesktop();
  const responsiveSize = size ?? (isDesktop ? "sm" : "xs");
  const responsiveTextSize = textSize ?? (isDesktop ? "md" : "sm");

  if (!text) {
    return <Loader type={type} size={responsiveSize} color={color} />;
  }

  if (textPosition === "center") {
    return (
      <Group gap={gap} justify="center" align="center" wrap="nowrap">
        <Loader type={type} size={responsiveSize} color={color} />
        <CustomText c={textColor} size={responsiveTextSize}>
          {text}
        </CustomText>
      </Group>
    );
  }
  return (
    <Group gap={gap} align="center" wrap="nowrap">
      {textPosition === "left" && (
        <CustomText c={textColor} size={responsiveTextSize}>
          {text}
        </CustomText>
      )}
      <Loader type={type} size={responsiveSize} color={color} />
      {textPosition === "right" && (
        <CustomText c={textColor} size={responsiveTextSize}>
          {text}
        </CustomText>
      )}
    </Group>
  );
}
